var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVector1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 169,
    height: 263,
    viewBox: "0 0 169 263",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M110.167 257C110.167 259.946 112.554 262.333 115.5 262.333C118.446 262.333 120.833 259.946 120.833 257C120.833 254.054 118.446 251.667 115.5 251.667C112.554 251.667 110.167 254.054 110.167 257ZM116.5 257V107.25H114.5V257H116.5ZM169 54.75V41.25H167V54.75H169ZM128.25 0.5H0.5V2.5H128.25V0.5ZM169 41.25C169 18.7444 150.756 0.5 128.25 0.5V2.5C149.651 2.5 167 19.849 167 41.25H169ZM141.75 82C156.8 82 169 69.7998 169 54.75H167C167 68.6952 155.695 80 141.75 80V82ZM116.5 107.25C116.5 93.3048 127.805 82 141.75 82V80C126.7 80 114.5 92.2002 114.5 107.25H116.5Z",
    fill: "url(#paint0_linear_4072_7269)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4072_7269",
    x1: 164.037,
    y1: -10.3286,
    x2: 11.0678,
    y2: -10.3286,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4B448"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4B448",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector1);
export default __webpack_public_path__ + "static/media/vector_1.5274e87eea9453a50a5af4832892b218.svg";
export { ForwardRef as ReactComponent };